import { render, staticRenderFns } from "./ClientProject.vue?vue&type=template&id=76590ee4&"
import script from "./ClientProject.vue?vue&type=script&lang=js&"
export * from "./ClientProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports